"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const MetricItem_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Metrics/MetricItem.vue"));
const lucide_vue_next_2 = require("lucide-vue-next");
const project_1 = require("@becrop/components/Results/Abstract/Interfaces/project");
const Recommendations_1 = require("@becrop/abstract/Models/Recommendations");
const EventTracker_1 = __importDefault(require("@becrop/abstract/Utils/EventTracker"));
let MapTooltipMetricSection = class MapTooltipMetricSection extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.eventTracker = new EventTracker_1.default();
    }
    mainActionClicked() {
        this.$emit('mainActionClicked');
        this.eventTrackerListener('dowloadReportFieldReport', { field: this.currentField.name, id: this.currentField.id });
    }
    eventTrackerListener(eventName, eventValues) {
        this.eventTracker.trackEvent(eventName, eventValues);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], MapTooltipMetricSection.prototype, "isLoadingOpenReport", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: new Recommendations_1.FieldRecommendation({}, []) })
], MapTooltipMetricSection.prototype, "currentField", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: true })
], MapTooltipMetricSection.prototype, "hasInteraction", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], MapTooltipMetricSection.prototype, "hasDownloadableReport", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], MapTooltipMetricSection.prototype, "hasFieldAgInsightForMetric", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: new project_1.BioMetric({}, {}) })
], MapTooltipMetricSection.prototype, "currentMetric", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], MapTooltipMetricSection.prototype, "currentZone", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], MapTooltipMetricSection.prototype, "type", void 0);
MapTooltipMetricSection = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Button: bmk_ui_framework_1.Button,
            ArrowDown: lucide_vue_next_1.ArrowDown,
            Tag: bmk_ui_framework_1.Tag,
            MetricItem: MetricItem_vue_1.default,
            Info: lucide_vue_next_2.Info
        },
    })
], MapTooltipMetricSection);
exports.default = MapTooltipMetricSection;
